<template>
  <div class="authorization-login-promo" @click="redirect">
    <atomic-picture
      class="authorization-login-promo__img"
      :src="defaultImage"
      :key="defaultImage"
      not-lazy
      alt="login"
    />

    <div class="authorization-login-promo__wrap">
      <div class="authorization-login-promo__top">
        <div class="authorization-login-promo__text">
          <span class="authorization-login-promo__text-top">
            {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.bonusLine1') }}
          </span>
          {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.bonusLine2') }}
          {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.bonusValue') }}
        </div>

        <div class="authorization-login-promo__text-small">
          {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.bonusTextValue') }}
          {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.bonusSubValue') }}
        </div>
      </div>

      <div class="authorization-login-promo-bottom">
        <div class="authorization-login-promo-bottom__item authorization-login-promo__text-small">
          <span class="authorization-login-promo__text-small-bold">
            {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.ratedEvent.rated') }}
          </span>

          {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.ratedEvent.category') }}
        </div>

        <div class="authorization-login-promo-bottom__item authorization-login-promo__text-small">
          <span class="authorization-login-promo__text-small-bold">
            {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.cashback.value') }}
          </span>

          {{ getContent(popupsData, defaultLocalePopupsData, 'authorization.banner.cashback.text') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const emits = defineEmits<{
    (event: 'closeModal'): void;
  }>();

  const deviceStore = useDeviceStore();
  const { isMobile } = storeToRefs(deviceStore);
  const { getContent, localizePath } = useProjectMethods();

  const { popupsData, defaultLocalePopupsData } = storeToRefs(useGlobalStore());

  const router = useRouter();

  const mobileImage = computed(() =>
    getContent(popupsData.value, defaultLocalePopupsData.value, 'authorization.banner.loginMobileImg')
  );
  const desktopImage = computed(() =>
    getContent(popupsData.value, defaultLocalePopupsData.value, 'authorization.banner.loginImg')
  );

  const defaultImage = computed(() => (isMobile.value ? mobileImage.value : desktopImage.value));

  const redirect = async () => {
    emits('closeModal');
    await router.push(localizePath('/welcome-package'));
  };
</script>

<style src="~/assets/styles/components/authorization/login-promo.scss" lang="scss" />
